// src/CiqlerDetail.js
import React from "react";
import "./CanvasBrew.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function CanvasBrewDetail() {
  return (
    <div>
      {/* Navigation Bar */}
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>

      {/* Main Background */}
      <div className="mainbackground">
        <div className="canvasbrew-project-detail notion-style">
          {/* Video Section */}
          <div className="canvasbrew-video-container">
            <video
              controls
              width="100%"
              src={`${process.env.PUBLIC_URL}/CanvasBrew.mp4`}
            />
          </div>

          {/* Detail Content */}
          <div className="detail-content">
            <div className="text-container">
              <h1>CanvasBrew</h1>
              <div className="projectImage">
                <img src={`${process.env.PUBLIC_URL}/canvasbrew.png`}></img>
              </div>
              <h2>Problem Statement</h2>
              <p>
                The Finance Controller of a consulting firm with over 2,000
                employees, operating across diverse industries, faced
                significant challenges in managing and visualizing complex
                financial data. Financial reporting was time-consuming and
                inefficient, requiring manual efforts to create clear and
                insightful presentations. The existing process hindered quick
                decision-making, making it difficult to present data effectively
                to stakeholders.{" "}
              </p>
              <h2>Value Proposition</h2>
              Over the course of three months, we developed a solution to
              streamline the financial reporting process. By automating the
              transformation of complex financial data into clear, insightful
              PowerPoint presentations, we enabled the Finance Controller to
              save valuable time and improve decision-making efficiency. This
              initiative optimized the data visualization process, providing
              actionable insights quickly and effectively, thereby enhancing the
              overall financial reporting workflow.
              {/* Technologies */}
              <h2>Technology</h2>
              <ul>
                <li>Atlas MongoDB</li>
                <li>Python Fast API</li>
                <li>Pandas & Matplotlib</li>
                <li>React.js</li>
                <li>GitLab</li>
                <li>Docker</li>
              </ul>
            </div>
            <h2>Team</h2>
            <ul>
              <ul>
              <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/rodriguescandice/"
                    style={{ color: "inherit"}}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Candice Rodrigues
                  </a>
                </li>
                <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/eazhadik/"
                    style={{ color: "inherit" }}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Elizaveta Zhadik
                  </a>
                </li>
                <li style={{ marginLeft: "25px" }}>
                  <a
                    href="https://www.linkedin.com/in/ulugbekisroilov/"
                    style={{ color: "inherit" }}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Ulugbzek Isroilov
                  </a>
                </li>


              </ul>
            </ul>
            {/* Deployment Section */}
            <div>
              <h2>Status</h2>
              <p style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    backgroundColor: "#6C757D",
                    borderRadius: "50%",
                    display: "inline-block",
                    marginRight: "8px",
                  }}
                ></span>
                Offline, the software was previously online for several months
                hosted at the company end.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CanvasBrewDetail;
